module.exports = __webpack_public_path__ + "media/application/images/ui/buttons-google-282586094acdc96a437ab26588cf6c95.png";